import {
  CubeReducerState,
  CubeStatus,
  DisabledReasonType,
  VisibleEnabledFeatureAvailable
} from 'modules/Cube/domain/cube.domain.types'
import { match } from 'ts-pattern'

export const getEditQuoteAvailable = (
  prevState: CubeReducerState
): VisibleEnabledFeatureAvailable => {
  const { isArchived, status } = prevState.data.common
  if (isArchived) {
    return {
      available: {
        visible: true,
        enabled: false
      },
      reasons: [
        {
          reasonType: DisabledReasonType.CantChangeWhenArchived,
          metadata: {}
        }
      ]
    }
  }

  if (prevState.data.quote.runningQuoteApprovalAutomationExecutionId) {
    return {
      available: { visible: true, enabled: false },
      reasons: [
        { reasonType: DisabledReasonType.PendingApproval, metadata: {} }
      ]
    }
  }

  if (
    status === CubeStatus.QuotePreparingSignatureRequest ||
    status === CubeStatus.QuoteAccepted ||
    status === CubeStatus.QuoteExecuted
  ) {
    return {
      available: {
        visible: true,
        enabled: false
      },
      reasons: [
        {
          reasonType: match(status)
            .with(
              CubeStatus.QuotePreparingSignatureRequest,
              () => DisabledReasonType.CantChangeWhenPreparingSignatureRequest
            )
            .with(
              CubeStatus.QuoteAccepted,
              () => DisabledReasonType.CantChangeWhenAccepted
            )
            .with(
              CubeStatus.QuoteExecuted,
              () => DisabledReasonType.CantChangeWhenExecuted
            )
            .exhaustive(),
          metadata: {}
        }
      ]
    }
  }

  return {
    available: {
      visible: true,
      enabled: true
    },
    reasons: []
  }
}
